module.exports = __webpack_public_path__ + "static/story4-02-800x533-c96db879b8ec9a64658101b7c39479c3.jpg";